export default "__VITE_PUBLIC_ASSET__8fa33cb1__"